import type {RenewRepresentativeContractFormPayload} from "./renew-representative-contract.schema";
import type {RenewRepresentativeContractRequest} from "@project/sdk/sales";

export const renewRepresentativeContractMapper = {
  toSdk: (payload: RenewRepresentativeContractFormPayload): RenewRepresentativeContractRequest => ({
    contract: payload,
  }),
};
